import React from 'react';
import { PRODUCT_IMAGES } from '../../data/mock';
import { Instagram } from 'lucide-react';

const GRID = [
  { url: PRODUCT_IMAGES.catSkincare, caption: 'Monday’s routine. Clean start.' },
  { url: PRODUCT_IMAGES.lookbookA,   caption: 'Soft golds for soft days.' },
  { url: PRODUCT_IMAGES.catJewelry,  caption: 'Layered, lightly.' },
  { url: PRODUCT_IMAGES.heroMen,     caption: 'The chain, always.' },
  { url: PRODUCT_IMAGES.catSelfcare, caption: 'Permission to pause.' },
  { url: PRODUCT_IMAGES.catGrooming, caption: 'Grooming, considered.' },
];

export default function InstagramFeed() {
  return (
    <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8">
      <div className="text-center">
        <p className="eyebrow text-espresso/60">@auraandore</p>
        <h2 className="mt-3 font-display text-4xl md:text-5xl">Live from the studio.</h2>
        <a href="https://instagram.com/" target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-2 text-xs tracking-[0.18em] text-espresso hover:text-gold">
          <Instagram className="size-4" /> FOLLOW ON INSTAGRAM
        </a>
      </div>
      <div className="mt-10 grid grid-cols-2 gap-2 md:grid-cols-3 lg:grid-cols-6">
        {GRID.map((g, i) => (
          <a key={i} href="https://instagram.com/" target="_blank" rel="noreferrer" className="group relative block aspect-square overflow-hidden bg-champagne">
            <img src={g.url} alt={g.caption} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
            <div className="absolute inset-0 flex items-end bg-gradient-to-t from-espresso/70 to-transparent p-3 opacity-0 transition-opacity group-hover:opacity-100">
              <p className="text-xs text-ivory">{g.caption}</p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
